import {
    useEffect,
} from 'react';
import { 
    useTheme, 
    useMediaQuery, 
    Pagination as MUIPagination,
} from '@mui/material';

const Pagination = ({ offset, totalPages, handleOffsetChange }) => {
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.only('xs'));
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [offset]);
    return (
        <MUIPagination
            count={totalPages} 
            page={+offset + 1} 
            variant="outlined" 
            color="primary" 
            size={matches ? "medium" : "large"}
            onChange={handleOffsetChange}
            sx={{
                '& .MuiPaginationItem-root.Mui-selected': {
                    color: theme.palette.text.main,
                    backgroundColor: theme.palette.action.hover,
                    fontWeight: 'bold',
                    border: `1px solid ${theme.palette.text.main}`,
                    '&:hover': {
                        backgroundColor: theme.palette.action.hover,
                    },
                },
            }}
        />
    );
}

export default Pagination;